import { gql } from '@apollo/client';

export const ALL_STAKEHOLDER_TYPES = gql`
  query getStakeholderTypes($input: InstitutionTypesInput) {
    stakeholderTypes: getStakeholderTypes(input: $input) {
      id
      name
    }
  }
`;
